import '../../../node_modules/inputmask/dist/inputmask/jquery.inputmask';

// Static mask
$('input[type="tel"]').inputmask({
  'mask': '+7 (999) 999-99-99',
  'showMaskOnHover': false,
});